import React from 'react';
import { Form, Card, Button, Spinner } from 'react-bootstrap';
import { useUploadFile } from '../../../../../api/fileUpload/fileUpload.hooks';

const HeroEditor = ({ hero, onChange }) => {
  const { upload, isLoading: isUploading } = useUploadFile();

  const handleChange = (field, value) => {
    onChange({ ...hero, [field]: value });
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const result = await upload(file);
      handleChange('bgImg', result.url);
    } catch (err) {
      console.error('Upload failed:', err);
    }
  };

  return (
    <Card className="mb-3">
      <Card.Header className='bg-neutral-gray'>
        <h5 className="mb-0">Hero Section</h5>
      </Card.Header>
      <Card.Body>
        <Form.Group className="mb-3">
          <Form.Label>Heading</Form.Label>
          <Form.Control
            type="text"
            value={hero.heading}
            onChange={(e) => handleChange('heading', e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Paragraph</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={hero.paragraph}
            onChange={(e) => handleChange('paragraph', e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Background Image</Form.Label>
          <div>
            {hero.bgImg ? (
              <div className="position-relative d-inline-block">
                <img
                  src={hero.bgImg}
                  alt="Hero Background"
                  style={{ width: '300px', height: '200px', objectFit: 'cover', borderRadius: '4px' }}
                />
                <Button
                  variant="danger"
                  size="sm"
                  className="position-absolute top-0 end-0"
                  style={{ transform: 'translate(50%, -50%)' }}
                  onClick={() => handleChange('bgImg', '')}
                >
                  <i className="fa fa-times"></i>
                </Button>
              </div>
            ) : (
              <Button
                variant="outline-primary"
                as="label"
                disabled={isUploading}
              >
                {isUploading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-1" />
                    Uploading...
                  </>
                ) : (
                  <>
                    <i className="fa fa-upload me-1"></i> Upload Image
                  </>
                )}
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={handleImageUpload}
                />
              </Button>
            )}
          </div>
        </Form.Group>
      </Card.Body>
    </Card>
  );
};

export default HeroEditor;
